import React from 'react';
import Hero from '../components/Hero';
import Navbar from '../components/Navbar';
import CountdownTimer from '../components/CountdownTimer';
import OurStory from '../components/OurStory';
import EventDetails from '../components/EventDetails';
import WeddingParty from '../components/WeddingParty';
import Gallery from '../components/Gallery';
import Footer from '../components/Footer';
export function MainSite() {
  return <div className="font-sans text-gray-800 bg-ivory" data-id="element-288">
      <Navbar data-id="element-289" />
      <Hero data-id="element-290" />
      <CountdownTimer data-id="element-291" />
      <OurStory data-id="element-292" />
      <EventDetails data-id="element-293" />
      <WeddingParty data-id="element-294" />
      <Gallery data-id="element-295" />
      <Footer data-id="element-296" />
    </div>;
}